var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.topBarHeight()
  var m1 = _vm.topBarTop()
  var m2 = _vm.topBarTop()
  var m3 = _vm.topBarHeight()
  var m4 = !(m3 == 0) ? _vm.topBarHeight() : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }